import React from "react";

// Stops focus events from bubbling to the SidebarLayout's Tooltip wrapper, which opens its hint on any focus inside
// the slot (Popover.Button focus, a click inside the open panel, focus-return on close) and draws it over the panel.
export const TooltipFocusGuard: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div onFocus={(e) => e.stopPropagation()}>{children}</div>
);
